"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const ActiveGroup_vue_1 = __importDefault(require("./target/ActiveGroup.vue"));
const ActiveSubgroup_vue_1 = __importDefault(require("./target/ActiveSubgroup.vue"));
const ActiveSample_vue_1 = __importDefault(require("./target/ActiveSample.vue"));
const ActiveCell_vue_1 = __importDefault(require("./target/ActiveCell.vue"));
let TargetProps = class TargetProps extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.element = null;
    }
    onChangeActive() {
        this.element = this.heatmap.activeElement;
        this.$emit('ontoggletarget', true);
    }
    get color() {
        if (this.element && this.element.color)
            return this.element.color;
        return 'grey';
    }
    capitalize(value) {
        if (!value)
            return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    /*
    // TODO: remove
    @Prop()
    activeElement!: {
        blockLevel: string,
        tree: {
            group: string,
            subgroup: string,
            sample: string
        },
        name: string,
        hidden: boolean,
        subgroup_criteria: string,
        subgroup_extra_options: {
            type: string,
            val: number
        },
        order_criteria: string,
        order_criteria_option: string,
        color: string
    }
    
    pathAvailable: string[] = ['subgroup', 'sample', 'cell']
    editionAvailable: string[] = ['group', 'subgroup']
    */
    expand() {
        this.$emit('ontoggletarget', !this.options.expanded);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TargetProps.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TargetProps.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.activeElement')
], TargetProps.prototype, "onChangeActive", null);
TargetProps = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Disc: lucide_vue_next_1.Disc,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            EyeOff: lucide_vue_next_1.EyeOff,
            Eye: lucide_vue_next_1.Eye,
            CornerDownRight: lucide_vue_next_1.CornerDownRight,
            ActiveGroupVue: ActiveGroup_vue_1.default,
            ActiveSubgroupVue: ActiveSubgroup_vue_1.default,
            ActiveSampleVue: ActiveSample_vue_1.default,
            ActiveCellVue: ActiveCell_vue_1.default,
        }
    })
], TargetProps);
exports.default = TargetProps;
